import {Box} from '@dropbox/dig-foundations';
import {Layout} from 'components/DSYS/Layout';
import {getDefaultTeamsRoute} from 'constant';
import {t} from 'i18next';
import {ReactNode} from 'react';

import {TeamsSection, TeamsSectionSwitch} from './TeamsSectionTabs';

/**
 * The Teams area's page (Teams, Components and Services, Apps): "Teams" at the
 * shared title spot with the section switch under it, the section's directory in
 * the rail, and its detail in a pane at the page gutter. One shell, so switching
 * tabs never moves the page.
 */
export const TeamsPage = ({
  active,
  rail,
  action,
  children,
}: {
  active: TeamsSection;
  // The create button after the title, like Workstreams' and News'.
  action?: ReactNode;
  // Undefined drops the rail (e.g. while the org chart is expanded).
  rail?: ReactNode;
  children: ReactNode;
}) => (
  <Layout.Page
    header={
      <Layout.PageHeader
        title={t('teams')}
        titleTo={getDefaultTeamsRoute()}
        create={action}
        toolbar={<TeamsSectionSwitch active={active} />}
      />
    }
    // The rail's content as given: full-bleed trees sit directly in it, inputs
    // and lists wrap themselves (see railInset in the callers).
    rail={rail}
  >
    <Box
      paddingTop="24"
      paddingBottom="32"
      style={{flex: 1, minWidth: 0, minHeight: 0, overflow: 'auto'}}
    >
      <Layout.MaxWidth width="reading" inset>
        {children}
      </Layout.MaxWidth>
    </Box>
  </Layout.Page>
);
